import { render, staticRenderFns } from "./purchaseOrder.vue?vue&type=template&id=5de168f4&scoped=true"
import script from "./purchaseOrder.vue?vue&type=script&lang=js"
export * from "./purchaseOrder.vue?vue&type=script&lang=js"
import style0 from "./purchaseOrder.vue?vue&type=style&index=0&id=5de168f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de168f4",
  null
  
)

export default component.exports